import React, { useState, useEffect, useRef } from "react";
import "./StudentActivityMonthly.scss";
import { connect } from "react-redux";
import ParentHeader from "../../parentHeader/ParentHeader";
import images from "../../../utilities/images/images";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { format, addDays, subDays } from "date-fns";
import uiActions from "../../../redux/ui/action";
import axios from "axios";
import { PARENT_STUDENT_ATTENDANCE_URL } from "../../../custom_utilities/baseURL";
import "react-datepicker/dist/react-datepicker.css";
import "react-circular-progressbar/dist/styles.css";
import LoaderPopUp from "../../../components/loader/loader";
import StudentActivityMonthlyAttendance from "./StudentActivityMonthlyAttendance";

function StudentActivityMonthly(props) {
  let { rollNo, startLoading, finishLoading, loginFromParent, loader } = props;
  const [activityData, setActivityData] = useState({ allActivityDetails: {} });
  const [startDate, setStartDate] = useState(
    new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
  );
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    getActivityDetails();
  }, []);

  const getActivityDetails = async () => {
    if (endDate < startDate) return;
    const data = {
      method_name: "get_parent_attendance_activity",
      rollno: Number(rollNo),
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
    };
    startLoading();
    console.log("API Request Data:", data);

    try {
      const response = await axios.post(PARENT_STUDENT_ATTENDANCE_URL, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("ResponseData : ", response);
      console.log("API Response Data:", response?.data?.data);

      if (response.status === 200) {
        setActivityData((prevData) => ({
          ...prevData,
          allActivityDetails: response.data.data,
        }));
      } else {
        setActivityData({ allActivityDetails: {} });
      }
    } catch (error) {
      console.error("API Error:", error.message || error);
      setActivityData({ allActivityDetails: {} });
    } finally {
      finishLoading();
    }
  };

  useEffect(() => {
    console.log("Updated activityData:", activityData);
  }, [activityData]);

  return (
    <>
      {loginFromParent}
      <div className="container_grey_box">
        <div className="bckBtn-title">
          <Link
            className="backBtn"
            to={{
              pathname: "/parent-dashboard",
            }}
          >
            <img src={images.m2_backBtn} alt="backBtn" />
          </Link>
        </div>
        <div className="range_div">
          <div className="left">
            <p>Data showing from</p>
            <p>Search by specific date</p>
          </div>
          <div className="right">
            <div className="date">
              <p>From</p>

              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
              />
            </div>
            <div className="date">
              <p>To</p>

              <DatePicker
                selected={endDate}
                onChange={(date) => {
                  if (date >= startDate) {
                    setEndDate(date);
                  }
                }}
                dateFormat="dd/MM/yyyy"
                minDate={startDate}
                maxDate={new Date()}
              />
            </div>
            <button onClick={() => getActivityDetails()}>Continue</button>
          </div>
        </div>

        <StudentActivityMonthlyAttendance activityData={activityData} />
      </div>
      {loader && <LoaderPopUp />}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    rollNo: state.parentrootReducer.parentAuthReducer.user.st_rollno,
    loginFromParent: state.parentrootReducer.parentAuthReducer.loginFromParent,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentActivityMonthly);
